<!--
	THIS BASKET IS THE SITE BASKET, ALL ARTICLES IN THE BASKET
-->

<template>
	<div
		v-bind:style="{ height: height + 'px' }"
		v-bind:class="{ siteBasket: true, active: active }"
	>
		<div class="innerCart">
			<div v-if="!articles.length">
				<div class="emptyText">
					{{ $t("emptyBasket") }}
				</div>

				<div
					v-on:click="active = false"
					class="checkout black adapted button full-width"
				>
					{{ $t("close") }}
				</div>
				<!-- checkout -->
			</div>
			<!-- unpopulated -->

			<div class="full-height" v-if="articles.length">
				<div class="hide-for-desktop">
					<a
						href="/cgi-bin/ibutik/AIR_ibutik.fcgi?funk=bestall_steg1"
					>
						<div class="checkout black adapted button full-width">
							{{ $t("checkout") }}
						</div>
					</a>
				</div>
				<!-- show-for-mobile -->

				<div class="topSummary title hide-for-desktop float-left full-width large-spacing-top large-spacing-bottom">
					<div class="totalPrice spacing-bottom float-left full-width">
						<span class="txt float-left medium-large-text price-font">
							{{ $t("total") }}
						</span>
						<span class="cart-totalprice float-right">
							<span v-html="$t('currencyPrefix')"></span>
							{{ data.sum }}
							<span v-html="$t('currencySuffix')"></span>
						</span>
					</div>
					<!-- price -->
					<div class="freeShipping float-left full-width small-text">
						<!--
							<span class="txt float-left">
								{{ $t("leftToFreeShipping") }}
							</span>
							<span class="cart-leftToFreeShipping float-right">
								<span v-html="$t('currencyPrefix')"></span>
								{{ data.leftToFreePostage }}
								<span v-html="$t('currencySuffix')"></span>
							</span>
						-->
					</div>
					<!-- price -->
				</div>
				<!-- topSummary -->

				<div class="siteBasketArticles">

					<div v-for="article in articles"
						:key="article.id"
						class="articleRow">
						<div class="image">
							<img v-bind:src="getArticleImageDB(article)" />
						</div>
						<div class="information">
							<div class="name ellipsis title">
								{{ article.title }}
							</div>
							<div class="price">

								<div :class="{ originalPrice: true, oldPrice: article.campaignPrice }">
									<span v-html="$t('currencyPrefix')"></span>
										{{ article.price }}
									<span v-html="$t('currencySuffix')"></span>
								</div>

								<div v-if="article.campaignPrice" :class="{ newPrice: true }">
									<span v-html="$t('currencyPrefix')"></span>
										{{ article.campaignPrice }}
									<span v-html="$t('currencySuffix')"></span>
								</div>

							</div>
							<div class="qty style-forms">
								<select
									v-on:change="
										changeQty(article, false, $event)
									"
									v-model="article.quantity"
								>
									<option
										v-bind:value="i"
										v-for="i in 10"
										:key="i"
									>
										{{ i }}
									</option>
								</select>
							</div>
							<div
								v-on:click="changeQty(article, true, $event)"
								class="remove"
							>
								<i
									v-if="removeLoading[article.id]"
									class="fa fa-circle-o-notch fa-spin"
								></i>
								<i
									v-if="!removeLoading[article.id]"
									class="fa fa-trash"
								></i>
							</div>
						</div>
					</div>
					<!-- productRow -->
				</div>
				<!-- #shopCartArticles -->

				<div class="bottomSummary title show-for-desktop float-left full-width">

					<div class="totalPrice float-left full-width">
						<span class="txt float-left normal-text price-font">
							{{ $t("total") }}</span
						>
						<span class="cart-totalprice float-right price-font">
							{{ data.sumPrefix }}{{ Math.round(data.sum * 100) / 100
							}}{{ data.sumSuffix }}
						</span>
					</div>

					<a :href="checkoutUrl">
						<div class="checkout black adapted button full-width">
							{{ $t("checkout") }}
						</div>
					</a>

				</div>
				<!-- topSummary -->
			</div>
			<!-- !unpopukated -->
		</div>
		<!-- innerCart -->
	</div>
	<!-- siteBasket -->
</template>

<script>
require("lodash")

export default {

	data: function(){
		return{
			loading: false,
			active: false,
			height: 'auto',
			unpopulated: false,
			data: {
				sum: '',
				sumText: '',
				sumqty: '',
				sumSuffix: this.$t('currencySuffix'),
				sumPrefix: this.$t('currencyPrefix'),
				leftToFreePostage: '',
			},
			removeLoading: {},
			articles: []
		}
	},

	methods: {

		get(){

			var self = this;

			// Clear
			var articles = [];

			// Get
			window.apiHandler.getSiteCart(function(data){
				
				// Set articles
				if(data && typeof data.cart != 'undefined' && typeof data.cart.items != 'undefined' && data.cart.items.length){
					self.articles = data.cart.items;
					self.data.sum = data.cart.total

					self.$store.commit('siteBasket', {
						sum:  Math.round(data.cart.total * 100) / 100,
						qty: data.cart.quantity
					});

				}
				else{
					self.articles = [];
					self.data.sum = 0;
					self.$store.commit('siteBasket', {
						sum: '0',
						qty: '0'
					});
				}
	            	
			})

		},

		changeQty(article, remove, e){

			var self = this;

			if(remove){
				var qty = 0;
				self.$set(this.removeLoading, article.id, true)
			}
			else{
				var select = $(e.target);
				var qty = select.val();
			}

			// Make update
			window.apiHandler.changeSiteCartQty(

				// Success
				function(){
					self.$set(self.removeLoading, article.id, false)
					self.get();
				},

				// Fail
				function(){
					self.$set(self.removeLoading, article.id, false)
				},

				// Data to end
				{
					qty: qty,
					item: article.combinationID,
					rowIndex: article.rowIndex
				}
			);

		},

		setHeight(){
			// Recalc height
			if(!this.device.isDesktop){
				this.height = parseInt($("#app").height()) - parseInt($(".rightMenu").height())
			}
		}

	},

	created: function () {

		var self = this;

		// Swipe down
		$(".page").on('swiperight', function(){
			if(self.active)
            	self.active = false;
        });

		// When opening the basket
		window.eventHub.$on('loadBasket', function (ID) {

			// Set basket ID
			self.$store.commit('basketID', ID);
			
			// Populate basket
			window.vueRender(function(){
				self.get();
			})
			
		});

		// When opening the basket
		window.eventHub.$on('toggleSiteBasket', function () {
			self.get();
			self.setHeight();
			self.active = !self.active;
		});

		// When closing the basket
		window.eventHub.$on('closeSiteBasket', function (e) {

			var clickedInsideBasket = $(e.target).parents(".siteBasket").length
			var clickedIcon = $(e.target).parents(".cartContainer").length

			if(!clickedInsideBasket && !clickedIcon){
				self.active = false;
			}

		});

		window.eventHub.$on('openSiteBasket', function () {
			self.get();
			self.setHeight();
			self.active = true;
		});

	}
}
</script>

<style lang="scss">
	.siteBasket {
		/* Mobile and tablet */
		position: absolute;
		width: 0%;
		right: 0;
		overflow: hidden;
		transition: width 0.4s;
		background: white;
		transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
		z-index: 9;
		min-height: 100%;
		line-height: normal;
		top: 0px;
		border-top: 1px solid #eaeaea;

		/* Mobile */
		@media screen and (max-width: 844px) {
			z-index: 8;
		}

		/* Tablet */
		@media screen and (min-width: 845px) {
			top: 51px;
		}

		/* Desktop  */
		@media screen and (min-width: 1025px) {
			display: none;
			max-height: 555px;
			top: 51px;
			right: 0;
			width: 470px;
			min-height: auto;
			border: 1px solid #eaeaea;
		}

		&.active {
			@media screen and (max-width: 845px) {
				width: 360px;
			}

			@media screen and (min-width: 780px) {
				width: 300px;
			}

			@media screen and (min-width: 1025px) {
				display: block;
				width: 470px;
			}

			.innerCart {
				transform: translate3d(0, 0, 0);
				height: 100%;
				width: 100%;
				padding-right: 10px;
			}
		}

		.innerCart {
			position: absolute;
			padding: 20px;
			left: 0;
			top: 0;
			transform: translate3d(500px, 0, 0);
			transition: transform 0.4s;
			transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);

			/* Desktop*/
			@media screen and (min-width: 1025px) {
				position: static;
				padding: 12px;
			}

			/* Tablet */
			@media screen and (max-width: 845px) {
				padding: 10px;
			}

			/* Mobile */
			@media screen and (min-width: 780px) {
				padding: 15px;
			}
		}

		.emptyText {
			padding: 10px 10px 10px 0px;
			margin-bottom: 10px;
			font-size: 14px;
		}

		.bottomSummary {
			margin-top: 17px;
		}

		.checkout {
			font-size: 12px;
			margin-bottom: 10px;
			text-transform: uppercase;
			padding: 17px;
			color: white;

			@media screen and (max-width: 845px) {
				padding: 15px;
			}
		}

		.originalPrice{
			float: left;
			margin-right: 15px;
		}

		.oldPrice{
			color: grey;
			font-weight: 400;
			text-decoration: line-through;
		}

		.newPrice{
			float: left;
			color: rgb(178, 16, 16);
			font-weight: 400;
		}

		.totalPrice {
			text-transform: uppercase;
			font-size: 16px;
			font-weight: bold;
			margin-bottom: 12px;
			@media (max-height: 350px) {
				margin-bottom: 2px;
			}
		}

		.freeShipping {
			text-transform: uppercase;
			font-size: 14px;
			margin-bottom: 12px;
			display: flex;
			align-items: flex-start;

			@media (max-height: 350px) {
				margin-bottom: 10px;
			}

			span:first-child {
				flex: 1;
			}

			.cart-leftToFreeShipping {
				width: 5rem;
				text-align: right;
			}
		}
	}

	/* Product rows */
	.siteBasketArticles {
		max-height: 100%;

		/* Tablet */
		@media screen and (max-width: 1024px) {
			height: calc(100% - 100px);
			overflow: auto;
			width: 100%;
			padding-bottom: 75px;
		}

		/* Mobile */
		@media screen and (max-width: 845px) {
			height: calc(100% - 145px);
			overflow: auto;
			width: 100%;
			padding-bottom: 25px;
		}

		/* Desktop */
		@media screen and (min-width: 1025px) {
			max-height: 390px;
			overflow: auto;
		}

		.articleRow {
			float: left;
			width: 100%;
			margin-bottom: 15px;
			position: relative;
		}

		.image {
			float: left;
			width: 110px;

			/* Mobile */
			@media screen and (max-width: 845px) {
				width: 54px;
			}

			/* Desktop */
			@media screen and (min-width: 1025px) {
				width: 73px;
			}
		}

		.information {
			float: left;
			width: calc(100% - 125px);
			padding: 10px;

			/* Mobile */
			@media screen and (max-width: 845px) {
				padding: 0 10px;
			}

			/* Desktop */
			@media screen and (min-width: 1025px) {
				width: calc(100% - 73px);
			}
		}

		.price {
			font-family: "Lato";
			font-weight: 600;
			text-transform: uppercase;
			margin: 20px 0;
			float:left;
			width: 100%;
			clear: both;

			/* Mobile */
			@media screen and (max-width: 845px) {
				margin: 8px 0;
				font-size: 12px;
			}

			/* Desktop */
			@media screen and (min-width: 1025px) {
				margin: 11px 0;
			}
		}

		select {
			-webkit-appearance: none !important;
			-moz-appearance: none !important;
			border-radius: 0;
			background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zd…J2ZSI+PHBvbHlnb24gcG9pbnRzPSI1Ljk5MiwwIDIuOTkyLDMgLTAuMDA4LDAgIi8+PC9zdmc+);
			background-position: 100% center;
			background-repeat: no-repeat;
			border-style: solid;
			border-width: 1px;
			border-color: #ccc;
			color: rgba(0, 0, 0, 0.75);
			height: 34px;
			line-height: 23px;
			margin-bottom: 0;

			width: 72%;

			/* Mobile */
			@media screen and (max-width: 845px) {
				height: 30px;
				line-height: 17px;
			}

			/* Desktop */
			@media screen and (min-width: 1025px) {
				width: 30%;
			}
		}

		.name {
			font-size: 14px;

			/* Mobile */
			@media screen and (max-width: 845px) {
				font-size: 11px;
			}
		}

		.remove {
			position: absolute;
			right: 0;
			top: 50%;
			font-size: 21px;
			margin-top: -10px;
			padding: 10px 12px;
			cursor: pointer;
		}
	}
</style>



// WEBPACK FOOTER //
// SiteBasket.vue?b6a91512